<div class="ia-dialog-header__intro">
  <h2 class="modal-title" [attr.id]="titleId"><ng-content></ng-content></h2>
  <p *ngIf="description" [id]="titleId + '-description'">{{ description }}</p>
</div>
<button type="button" class="ia-dialog-header__close" aria-label="Close dialog" title="Close" [disabled]="dismissDisabled"
  (click)="dismissed.emit()">
  <svg aria-hidden="true" width="20" height="20" viewBox="0 0 24 24" fill="none">
    <path d="m6 6 12 12M18 6 6 18" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
  </svg>
</button>
